import React from "react";

export default function AppTextAmount({
  label,
  value,
  onChange,
  placeholder,
  type = "number",
  error,
  errorText,
  min = 500,
  icon,
  btnClickHandler,
  inpRef,
  autoFocus = false,
  showList = false,
  autoCompleteList = [],
  optionClickHandler,
  onKeyDown,
  onFocus,
  className = "",
}) {
  const isError = error && (value === "" || value < min);

  return (
    <div className="flex flex-col w-full relative">
      {label && (
        <label className="mb-1 text-sm font-medium text-gray-700">
          {label}
        </label>
      )}

      <div className={`relative flex items-center w-full`}>
        <input
          ref={inpRef}
          type={type}
          value={value}
          onChange={onChange}
          placeholder={placeholder}
          autoFocus={autoFocus}
          onKeyDown={onKeyDown}
          onFocus={onFocus}
          className={`w-full px-3 py-2 text-sm border rounded-lg outline-none  ${
            isError ? "border-red-500" : "border-gray-300"
          } ${icon ? "pr-10" : ""} ${className}`}
        />
        {icon && btnClickHandler && (
          <div
            onClick={() => btnClickHandler(inpRef.current)}
            className="absolute right-2 cursor-pointer text-gray-500 hover:text-gray-700"
          >
            {icon}
          </div>
        )}
      </div>

      {/* Autocomplete List */}
      {showList && autoCompleteList.length > 0 && (
        <div className="absolute top-full left-0 w-full bg-white border border-gray-300 rounded-lg shadow-lg z-10 mt-1 max-h-40 overflow-y-auto">
          {autoCompleteList.map((item, index) => (
            <div
              key={index}
              onClick={() => optionClickHandler(item)}
              className="px-3 py-2 cursor-pointer hover:bg-gray-100 text-sm text-gray-700"
            >
              {item}
            </div>
          ))}
        </div>
      )}

      {/* Error Message */}
      {isError && (
        <p className="mt-1 text-xs text-red-500">{errorText || `Minimum value is ${min}`}</p>
      )}
    </div>
  );
}
